import { useContext } from 'react';
import { TaskDashboardContext, TaskDashboardContextData } from './context';

export function useTaskDashboard(): TaskDashboardContextData {
    const data = useContext<TaskDashboardContextData | undefined>(
        TaskDashboardContext
    );

    if (!data) {
        throw new Error(
            "TaskDashboardContextData unavailable. Are you sure you're using this in a nested component of an TaskDashboardProvider?"
        );
    }

    return data;
}
